import {
  ENABLE_DEBUGGING,
  DISABLE_DEBUGGING,
  TOGGLE_FIREBASE_AUTH,
  TOGGLE_FIREBASE_DB,
  TOGGLE_API_JWT,
  SET_LOCALE,
} from '@app/actions/feature-toggles';

const initialState = {
  firebaseAuthEnabled: false,
  firebaseDbEnabled: false,
  apiJwtEnabled: false,
  debuggingEnabled: false,
  locale: 'pt-BR',
};

export default (state = initialState, action) => {
  const firebaseAuthEnabled = !state.firebaseAuthEnabled;
  const firebaseDbEnabled = !state.firebaseDbEnabled;
  const apiJwtEnabled = !state.apiJwtEnabled;

  switch (action.type) {
    case TOGGLE_FIREBASE_AUTH:
      return {
        ...state,
        firebaseAuthEnabled,
      };

    case TOGGLE_FIREBASE_DB:
      return {
        ...state,
        firebaseDbEnabled,
      };

    case TOGGLE_API_JWT:
      return {
        ...state,
        apiJwtEnabled,
      };

    case ENABLE_DEBUGGING:
      return {
        ...state,
        debuggingEnabled: true,
      };

    case DISABLE_DEBUGGING:
      return initialState;

    case SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducer/feature-toggles.js